<template>
  <div class="dashboard">
    <h2>产品组设置</h2>

    <!-- 功能区 -->
    <el-row class="toolbar" :gutter="20">
      <el-col :span="18">
        <el-button-group>
          <el-button 
            type="info" 
            icon="el-icon-refresh" 
            @click="handleRefresh"
          >刷新</el-button>
          <el-button 
            type="primary" 
            @click="showAddDialog"
          >新增产品组</el-button>
          <el-button 
            type="danger" 
            @click="handleBatchDelete"
          >批量删除</el-button>
        </el-button-group>
      </el-col>
      <!-- 搜索栏保持不变 -->
    </el-row>

    
    <!-- 数据表格 -->
    <el-table
        :data="filteredProducts"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        border
      >
        <el-table-column :resizable="false" type="selection" width="55" />
        <el-table-column :resizable="false" prop="name" label="产品组" width="180" />
        <el-table-column :resizable="false" label="描述">
          <template #default="{ row }">
            {{ row.configs.desc || '-- 无描述 --' }}
          </template>
        </el-table-column>

        <el-table-column :resizable="false" label="默认产品" width="200" >
          <template #default="{ row }">
            <div class="default-product-cell">
              <span>{{ row.configs.default || '无' }}</span>
              <el-button 
                v-if="row.scheduleIson" 
                type="text" 
                size="mini"
                class="schedule-active-link"
                @click="handleShowPlanStatus(row)"
              >
                计划任务中
              </el-button>
            </div>
          </template>
        </el-table-column>

        <!-- 在默认产品列上方添加状态列 -->
        <el-table-column :resizable="false" label="状态" width="120">
          <template #default="{ row }">
            <el-tag :type="row.isvaild ? 'success' : 'danger'" effect="dark">
              {{ row.isvaild ? '可用' : '异常' }}
            </el-tag>
          </template>
        </el-table-column>

         <el-table-column :resizable="false" prop="productnum" label="产品数量" width="120" />
        
        <!-- 规则列 -->
        <el-table-column :resizable="false" label="渠道映射" width="400">
          <template #default="{ row }">
            <div class="rule-config-cell">
              <el-tooltip 
                effect="dark" 
                placement="top"
                :disabled="!row.configs.src2tar || Object.keys(row.configs.src2tar).length === 0"
              >
                <template #content>
                  <div class="full-rule-content">
                    <div 
                      v-for="(value, key) in row.configs.src2tar" 
                      :key="key"
                      class="rule-tag"
                    >{{ key }} → {{ value }}</div>
                    <span v-if="!Object.keys(row.configs.src2tar).length">无渠道配置</span>
                  </div>
                </template>
                
                <div class="rule-tags-container">
                  <template v-if="Object.keys(row.configs.src2tar).length">
                    <div 
                      v-for="(value, key) in row.configs.src2tar" 
                      :key="key"
                      class="rule-tag"
                    >{{ key }} → {{ value }}</div>
                  </template>
                  <span v-else class="empty-rule">-- 无 --</span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 新增产品详情列 -->
        <el-table-column :resizable="false" label="产品详情">
          <template #default="{ row }">
            <el-button 
              type="text" 
              @click="handleViewDetails(row)"
            >查看详情</el-button>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column :resizable="false" label="操作" width="440">
         <template #default="{ $index, row }">
            <el-button 
              size="mini" 
              type="primary" 
              @click="handleCopyLink(row)"
              style="margin-right: 8px"
            >复制链接</el-button>
            <el-button 
              size="mini" 
              type="primary" 
              @click="showViewDialog(row)"
              style="margin-right: 8px"
            >编辑</el-button>
            <el-button 
              size="mini" 
              type="warning" 
              @click="handleScheduleTask(row)"
              style="margin-right: 8px"
            >计划任务
            </el-button>
            <el-button 
              size="mini" 
              type="danger" 
              @click="handleDelete(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="160px">
        <el-form-item label="产品组名称(不能中文)" required>
          <el-input 
            v-no-space
            v-model="formData.name" 
            :disabled="dialogType !== 'add'" 
            @input="handleNameInput"
          ></el-input>
        </el-form-item>

        <el-form-item label="产品组描述">
          <el-input
            v-model="formData.configs.desc"
            type="textarea"
            :rows="2"
            placeholder="请输入产品组描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="默认产品(不能中文)">
          <el-input 
            v-no-space
            v-model="formData.configs.default" 
            placeholder="请输入默认产品"
            @input="handleDefaultInput"
          ></el-input>
        </el-form-item>

        <el-form-item label="渠道映射">
          <div  class="kv-editor">
            <div v-for="(item, index) in src2tarList" :key="index" class="kv-row">
              <el-input v-no-space v-model="item.key" placeholder="渠道" style="width: 200px"></el-input>
              <span class="separator">→</span>
              <el-input v-no-space v-model="item.value" placeholder="产品" style="width: 200px"></el-input>
              <el-button
                type="danger" 
                icon="el-icon-delete"
                circle
                @click="removeKv(index)"
              ></el-button>
            </div>
            <el-button type="primary" plain @click="addKv">+ 添加映射</el-button>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <template>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 产品详情对话框 -->
    <el-dialog
      :title="selectedGroup + '产品详情'"
      :visible.sync="productDialogVisible"
      :close-on-click-modal="false"
      width="90%"
      top="5vh"
      custom-class="product-detail-dialog"
    >
      <product-component 
        :external-group="selectedGroup"
        v-if="productDialogVisible"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="hanldeCloseDetails">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 计划任务对话框 -->
    <el-dialog
      :title="'计划任务 - ' + scheduleGroupName"
      :visible.sync="scheduleDialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleScheduleDialogClose"
    >
      <div class="schedule-container">
        <!-- 编辑模式切换 -->
        <div class="schedule-edit-bar">
          <span class="schedule-edit-hint">
            <template v-if="scheduleEditable">
              <i class="el-icon-edit"></i> 编辑模式
            </template>
            <template v-else>
              <i class="el-icon-view"></i> 查看模式
            </template>
          </span>
          <el-button 
            :type="scheduleEditable ? 'default' : 'primary'"
            size="small"
            :icon="scheduleEditable ? 'el-icon-view' : 'el-icon-edit'"
            @click="toggleScheduleEdit"
          >
            {{ scheduleEditable ? '取消编辑' : '编辑' }}
          </el-button>
        </div>

        <!-- 总开关 -->
        <div class="schedule-switch-row">
          <span class="schedule-switch-label">计划任务总开关</span>
          <el-switch
            v-model="scheduleEnabled"
            active-text="已开启"
            inactive-text="已关闭"
            :disabled="!scheduleEditable"
          >
          </el-switch>
        </div>

        <el-divider></el-divider>

        <!-- 子项列表 -->
        <div class="schedule-items-header">
          <span class="schedule-items-title">任务列表</span>
          <el-button 
            v-if="scheduleEditable"
            type="primary" 
            size="small" 
            icon="el-icon-plus" 
            @click="addScheduleItem"
          >添加产品</el-button>
        </div>

        <!-- 子项列表 -->
        <div v-if="scheduleItems.length === 0" class="schedule-empty">
          <el-empty :description="scheduleEditable ? '暂无计划任务，请点击上方按钮添加' : '暂无计划任务'"></el-empty>
        </div>

        <div v-else class="schedule-items-list">
          <div 
            v-for="(item, index) in scheduleItems" 
            :key="index" 
            class="schedule-item-card"
          >
            <div class="schedule-item-header">
              <span class="schedule-item-index">产品 {{ index + 1 }}</span>
              <div class="schedule-item-actions">
                <el-button 
                  v-if="scheduleEditable"
                  type="primary" 
                  size="mini" 
                  icon="el-icon-arrow-up" 
                  circle
                  :disabled="index === 0"
                  @click="moveScheduleItemUp(index)"
                  title="上移"
                ></el-button>
                <el-button 
                  v-if="scheduleEditable"
                  type="primary" 
                  size="mini" 
                  icon="el-icon-arrow-down" 
                  circle
                  :disabled="index === scheduleItems.length - 1"
                  @click="moveScheduleItemDown(index)"
                  title="下移"
                ></el-button>
                <el-button 
                  v-if="scheduleEditable"
                  type="danger" 
                  size="mini" 
                  icon="el-icon-delete" 
                  circle
                  @click="removeScheduleItem(index)"
                ></el-button>
              </div>
            </div>
            <div class="schedule-item-body">
              <el-form :model="item" label-width="100px" size="small">
                <el-form-item label="产品名字">
                  <el-select 
                    v-model="item.product_name" 
                    placeholder="请选择产品"
                    filterable
                    clearable
                    style="width: 100%"
                    :disabled="!scheduleEditable"
                  >
                    <el-option
                      v-for="opt in productOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="目标返回码">
                  <template v-if="item.target_code === '__custom__'">
                    <div class="custom-code-row">
                      <el-select 
                        v-model="item.target_code" 
                        placeholder="请选择返回码"
                        style="width: 140px; flex-shrink: 0;"
                        :disabled="!scheduleEditable"
                      >
                        <el-option
                          v-for="opt in targetCodeOptions"
                          :key="opt.value"
                          :label="opt.label"
                          :value="opt.value"
                        ></el-option>
                      </el-select>
                      <el-input 
                        v-model="customTargetCodes[index]"
                        placeholder="请输入自定义返回码"
                        clearable
                        :disabled="!scheduleEditable"
                      ></el-input>
                    </div>
                  </template>
                  <el-select 
                    v-else
                    v-model="item.target_code" 
                    placeholder="请选择返回码"
                    filterable
                    clearable
                    style="width: 100%"
                    :disabled="!scheduleEditable"
                    @change="handleTargetCodeChange(index, $event)"
                  >
                    <el-option
                      v-for="opt in targetCodeOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="目标数量">
                  <el-input-number 
                    v-model="item.target_count" 
                    :min="1" 
                    :max="99999999"
                    :step="100"
                    controls-position="right"
                    style="width: 100%"
                    :disabled="!scheduleEditable"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="渠道限制">
                  <div class="channel-limit-editor">
                    <!-- 渠道模式选择 -->
                    <div class="channel-mode-row">
                      <el-radio-group 
                        v-model="item.channelMode" 
                        size="small"
                        :disabled="!scheduleEditable"
                        @change="handleChannelModeChange(item)"
                      >
                        <el-radio-button label="all">全部渠道</el-radio-button>
                        <el-radio-button label="specify">指定渠道</el-radio-button>
                      </el-radio-group>
                    </div>
                    <!-- 指定渠道列表 -->
                    <template v-if="item.channelMode === 'specify'">
                      <div 
                        v-for="(ch, chIndex) in item.channels" 
                        :key="chIndex" 
                        class="channel-limit-row"
                      >
                        <el-input
                          v-model="ch.name"
                          placeholder="请输入渠道名称"
                          clearable
                          size="small"
                          :disabled="!scheduleEditable"
                        ></el-input>
                        <el-button
                          v-if="scheduleEditable"
                          type="danger"
                          size="mini"
                          icon="el-icon-delete"
                          circle
                          @click="removeChannel(item, chIndex)"
                        ></el-button>
                      </div>
                      <el-button 
                        v-if="scheduleEditable"
                        type="primary" 
                        size="mini" 
                        plain
                        @click="addChannel(item)"
                        icon="el-icon-plus"
                      >添加渠道</el-button>
                    </template>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="scheduleDialogVisible = false">关 闭</el-button>
        <el-button 
          v-if="scheduleEditable"
          type="primary" 
          @click="submitScheduleTasks" 
          :loading="scheduleSaving"
        >保 存</el-button>
      </div>
    </el-dialog>

    <!-- 计划任务状态详情对话框 -->
    <el-dialog
      :title="'计划任务状态 - ' + planStatusGroupName"
      :visible.sync="planStatusDialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handlePlanStatusDialogClose"
    >
      <div class="plan-status-container" v-loading="planStatusLoading">
        <el-table
          :data="planStatusList"
          border
          stripe
          style="width: 100%"
          :empty-text="planStatusLoading ? '加载中...' : '暂无数据'"
        >
          <el-table-column prop="target" label="产品名称" min-width="160" />
          <el-table-column prop="transformType" label="目标返回码" width="120">
            <template #default="{ row }">
              {{ formatTransformType(row.transformType) }}
            </template>
          </el-table-column>
          <el-table-column prop="count" label="计划数量" width="120" />
          <el-table-column prop="currentCount" label="当前数量" width="120">
            <template #default="{ row }">
              <span :class="getCurrentCountClass(row)">{{ row.currentCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成进度" min-width="140">
            <template #default="{ row }">
              <el-progress 
                :percentage="getProgressPercentage(row)" 
                :status="getProgressStatus(row)"
                :stroke-width="16"
                :text-inside="true"
              ></el-progress>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="planStatusDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="refreshPlanStatus" :loading="planStatusLoading">刷 新</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {GroupList, AddGroup, UpdateGroup, DelGroup, GetProductTips, GetProducts, GetScheduleTasks, SaveScheduleTasks, GetGroupPlanDetails} from '../api/index'

import ProductComponent from '../components/ProductComponent.vue'

import { hasNotifiedToday, setNotifiedToday, resetNotification, isAllPlansCompleted } from '../utils/planNotification'

export default {
  name: 'Products',
  components: {
    ProductComponent
  },
  data() {
    return {
      searchKey: '',
      products: [],
      version:'',
      multipleSelection: [],
      dialogVisible: false,
      isEditMode: false,
      dialogType: 'add', // add/view
      formData: {
        name: '',
        configs: {
          default: '',
          src2tar: {}
        }
      },
      src2tarList: [],
      loading:false,
      productDialogVisible: false,
      selectedGroup: '',
      // 计划任务相关
      scheduleDialogVisible: false,
      scheduleGroupName: '',
      scheduleEnabled: false,
      scheduleItems: [],
      scheduleSaving: false,
      scheduleVersion:'',
      // 产品列表（用于下拉选择）
      productOptions: [],
      // 返回码选项
      targetCodeOptions: [
        { label: '激活(1)', value: '1' },
        { label: '注册(2)', value: '2' },
        { label: '次留(3)', value: '3' },
        { label: '唤醒(5)', value: '5' },
        { label: '付费(8)', value: '8' },
        { label: '自定义', value: '__custom__' }
      ],
      // 自定义返回码输入
      customTargetCodes: {},
      // 计划任务编辑模式
      scheduleEditable: false,
      // 计划任务状态详情
      planStatusDialogVisible: false,
      planStatusGroupName: '',
      planStatusList: [],
      planStatusLoading: false,
    }
  },
  computed: {
    filteredProducts() {
      return this.products.filter(item => 
        item.name.toLowerCase().includes(this.searchKey.toLowerCase()))
    },
    dialogTitle() {
      return this.dialogType === 'add' ? '新增产品组' : '编辑产品组'
    }
  },
  created(){
    this.getList()
  },
  methods: {

    // 新增刷新方法
    handleRefresh() {
      this.getList()
      this.$message.success("已刷新")
    },

    getList(){
      this.loading = true
      GroupList().then(res => {
        const groups = res.data || []
        this.version = res.version
        
        // 为每个组加载计划任务状态，判断是否开启
        const loadPromises = groups.map(group => {
          return GetScheduleTasks(group.name).then(scheduleRes => {
            try {
              const configs = scheduleRes.data.configs
              if (configs && configs !== '') {
                const data = JSON.parse(configs)
                group.scheduleIson = data.ison || false
              } else {
                group.scheduleIson = false
              }
            } catch (e) {
              group.scheduleIson = false
            }
            return group
          }).catch(() => {
            group.scheduleIson = false
            return group
          })
        })

        return Promise.all(loadPromises)
      }).then(groups => {
        this.products = groups
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.$message.error('获取数据失败:'+error)
      })
    },

    handleViewDetails(row) {
      this.selectedGroup = row.name
      this.productDialogVisible = true
    },

    hanldeCloseDetails(){
      this.productDialogVisible = false
      this.getList()
    },

    // 显示新增对话框
    showAddDialog() {
      this.dialogType = 'add'
      this.isEditMode = true
      this.resetForm()
      this.dialogVisible = true
    },
    // 显示查看对话框
    showViewDialog(row) {
      this.dialogType = 'view'
      this.isEditMode = false
      this.formData = JSON.parse(JSON.stringify(row))
      this.src2tarList = Object.entries(row.configs.src2tar).map(([key, value]) => ({
        key,
        value
      }))
      this.dialogVisible = true
    },

    // 进入编辑模式
    enterEditMode() {
      this.isEditMode = true
      this.src2tarList = Object.entries(this.formData.configs.src2tar).map(([key, value]) => ({
        key,
        value
      }))
    },

    // 添加键值对
    addKv() {
      this.src2tarList.push({ key: '', value: '' })
    },

    // 删除键值对
    removeKv(index) {
      this.src2tarList.splice(index, 1)
    },

     // 提交表单
    submitForm() {
      // 转换src2tar格式
      const src2tar = this.src2tarList.reduce((acc, cur) => {
        if (cur.key && cur.value) {
          acc[cur.key] = cur.value
        }
        return acc
      }, {})

      const newData = {
        ...this.formData,
        configs: {
          ...this.formData.configs,
          src2tar: src2tar,
          desc: this.formData.configs.desc || '' // 确保desc字段存在
        }
      }

      if (this.dialogType === 'add') {

        AddGroup(newData).then(() => {
          this.getList()
          this.$message.success("添加成功")
        }).catch(() => {
          this.$message.error('添加失败')
        })

      } else {
        console.log("版本",this.version)
        UpdateGroup(this.formData.name, {...newData.configs,version:this.version}).then(() => {
          this.getList()
          this.$message.success("保存成功")
        }).catch(() => {
          this.$message.error('保存失败')
        })
      }

      this.dialogVisible = false
    },

    // 重置表单
    resetForm() {
      this.formData = {
        name: '',
        configs: {
          default: '',
          src2tar: {},
          desc:'',
        }
      }
      this.src2tarList = []
    },

    handleSearch() {
      // 搜索逻辑已通过计算属性自动处理
    },

    handleDelete(row) {
      this.$confirm('确定要删除该产品组吗？', '警告', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        DelGroup({names:[row.name], version:this.version}).then(() => {
          this.getList()
          this.$message.success("删除成功")
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },

    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要删除的项目')
        return
      }

      this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 个项目吗？`, '批量删除', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var dels = []
        this.multipleSelection.forEach(item => {
          dels.push(item.name)
        })
        DelGroup(dels).then(() => {
          this.getList()
          this.$message.success("删除成功")
        }).catch(error => {
          this.$message.error('删除失败:'+error)
        })
      }).catch(() => {})
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 通用复制方法：优先使用 Clipboard API，降级使用 execCommand
    copyToClipboard(text) {
      return new Promise((resolve, reject) => {
        // 优先使用 Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(resolve).catch(err => {
            console.warn('Clipboard API 失败，尝试降级方案:', err)
            // 降级到 execCommand
            this.fallbackCopy(text, resolve, reject)
          })
        } else {
          // 不支持 Clipboard API，直接使用降级方案
          this.fallbackCopy(text, resolve, reject)
        }
      })
    },
    // 降级复制方案：使用 document.execCommand('copy')
    fallbackCopy(text, resolve, reject) {
      try {
        // 创建一个临时的 textarea 元素
        const textarea = document.createElement('textarea')
        textarea.value = text
        // 设置不可见样式
        textarea.style.position = 'fixed'
        textarea.style.left = '-9999px'
        textarea.style.top = '-9999px'
        textarea.style.opacity = '0'
        textarea.style.width = '1px'
        textarea.style.height = '1px'
        textarea.style.padding = '0'
        textarea.style.border = 'none'
        textarea.style.outline = 'none'
        textarea.style.boxShadow = 'none'
        textarea.style.background = 'transparent'
        document.body.appendChild(textarea)
        
        // 选中文本
        textarea.focus()
        textarea.select()
        
        // 对于移动端，需要设置 selection range
        if (document.createRange) {
          const range = document.createRange()
          range.selectNodeContents(textarea)
          const selection = window.getSelection()
          selection.removeAllRanges()
          selection.addRange(range)
        }
        
        // 执行复制命令
        const successful = document.execCommand('copy')
        document.body.removeChild(textarea)
        
        if (successful) {
          resolve()
        } else {
          reject(new Error('execCommand 复制失败'))
        }
      } catch (err) {
        console.error('降级复制方案失败:', err)
        reject(err)
      }
    },
    handleCopyLink(row) {
      if(!row.configs.default){
        this.$message.error("默认产品为空")
        return
      }

      GetProductTips(row.configs.default).then(res=>{
            var tipstr = ""
            for(var k in res.data){
            var title = k + "链接:"
            if(k == "comm")
            {
                title = "通用链接:"
            }
            if(tipstr == "")
            {
                tipstr =title +"\n"+ "http://ocpx.sfkjad.com/comm/?group="+row.name +"&" + res.data[k] 
            }else{
                tipstr = tipstr + "\n\n" + title +"\n" + "http://ocpx.sfkjad.com/comm/?group=" + row.name +"&" + res.data[k] 
            }
            }
            // 使用通用复制方法
            this.copyToClipboard(tipstr).then(() => {
              this.$message.success('已复制到剪贴板')
            }).catch(err => {
              console.error('所有复制方案均失败:', err)
              // 最终降级：弹出提示让用户手动复制
              this.$alert('复制失败，请手动复制以下内容：\n\n' + tipstr, '复制提示', {
                confirmButtonText: '我知道了',
                dangerouslyUseHTMLString: false,
                type: 'warning'
              })
            })
      }).catch(err=>{
        this.$message.error("获取链接失败:"+err)
      })
    },
    // 处理产品组名称输入
    handleNameInput(value) {
      this.formData.name = value.replace(/[^\w]/g, '');
    },

    // 处理默认产品输入
    handleDefaultInput(value) {
      this.formData.configs.default = value.replace(/[^\w]/g, '');
    },
    formatSrc2tar(src2tar) {
      if (!src2tar || Object.keys(src2tar).length === 0) return ''
      return Object.entries(src2tar)
        .map(([k, v]) => `${k}→${v}`)
        .join(', ')
    },
    // ==================== 计划任务相关方法 ====================

    // 切换计划任务编辑模式
    toggleScheduleEdit() {
      this.scheduleEditable = !this.scheduleEditable
    },

    // 点击计划任务按钮
    handleScheduleTask(row) {
      this.scheduleGroupName = row.name
      this.scheduleDialogVisible = true
      this.scheduleEditable = false
      this.scheduleEnabled = false
      this.scheduleItems = []
      // 加载产品列表供下拉选择
      this.loadProductOptions()
      this.loadScheduleData(row.name)
    },

    // 加载产品列表（用于下拉选择，通过 query 参数只获取当前组的产品）
    loadProductOptions() {
      GetProducts({ group: this.scheduleGroupName }).then(res => {
        const products = res.data || []
        this.productOptions = products.map(item => ({
          label: item.name,
          value: item.name
        }))
      }).catch(error => {
        console.log('获取产品列表失败:', error)
        this.productOptions = []
      })
    },

    // 加载计划任务数据
    loadScheduleData(groupName) {
      // 调用后端接口获取计划任务数据
      // TODO: 请根据实际后端接口调整请求参数
      GetScheduleTasks(groupName).then(res => {

        this.scheduleVersion = res.version

        if(res.data.configs == "")
        {
          this.scheduleEnabled = false
          this.scheduleItems = []
          return
        }else{
          const data = JSON.parse(res.data.configs)
          this.scheduleEnabled = data.ison || false
          this.scheduleItems = (data.plans || []).map(item => {
            const channels = []

            if(item.srcLimit)
            {
              for(var k in item.srcLimit)
              {
                channels.push(k)
              } 
            }

            // 判断渠道模式：如果 channels 包含 '__all__' 则为全部渠道模式
            const hasAll = channels.includes('all')
            return {
              product_name: item.target || '',
              target_code: item.transformType || '',
              target_count: item.targetCount || 1,
              channelMode: hasAll ? 'all' : 'specify',
              channels: hasAll ? [] : channels.map(ch => ({ name: ch }))
            }
          })
        }

        
      }).catch(error => {
        // 如果获取失败（比如还没有创建过计划任务），使用默认空数据
        console.log('获取计划任务数据失败，使用默认空数据:', error)
        this.scheduleEnabled = false
        this.scheduleItems = []
      })
    },

    // 目标返回码选择变化处理
    handleTargetCodeChange(index, value) {
      if (value === '__custom__') {
        // 初始化自定义返回码输入
        this.$set(this.customTargetCodes, index, '')
      } else {
        // 清除自定义返回码
        this.$delete(this.customTargetCodes, index)
      }
    },

    // 添加渠道限制
    addChannel(item) {
      if (!item.channels) {
        this.$set(item, 'channels', [])
      }
      item.channels.push({
        name: ''
      })
    },

    // 删除渠道限制
    removeChannel(item, chIndex) {
      item.channels.splice(chIndex, 1)
    },

    // 渠道模式切换处理
    handleChannelModeChange(item) {
      if (item.channelMode === 'all') {
        // 切换到全部渠道，清空指定渠道列表
        item.channels = []
      } else {
        // 切换到指定渠道，初始化一个空渠道输入
        if (!item.channels || item.channels.length === 0) {
          item.channels = [{ name: '' }]
        }
      }
    },

    // 添加计划任务子项
    addScheduleItem() {
      this.scheduleItems.push({
        product_name: '',
        target_code: '',
        target_count: 1,
        channelMode: 'all',
        channels: []
      })
      // 新建任务计划时，默认开启任务计划开关
      this.scheduleEnabled = true
    },

    // 上移计划任务子项
    moveScheduleItemUp(index) {
      if (index <= 0) return
      // 交换当前项与前一项的位置
      const temp = this.scheduleItems[index - 1]
      this.$set(this.scheduleItems, index - 1, this.scheduleItems[index])
      this.$set(this.scheduleItems, index, temp)
      
      // 同时交换对应的自定义返回码
      const tempCode = this.customTargetCodes[index - 1]
      this.$set(this.customTargetCodes, index - 1, this.customTargetCodes[index])
      this.$set(this.customTargetCodes, index, tempCode)
    },

    // 下移计划任务子项
    moveScheduleItemDown(index) {
      if (index >= this.scheduleItems.length - 1) return
      // 交换当前项与后一项的位置
      const temp = this.scheduleItems[index + 1]
      this.$set(this.scheduleItems, index + 1, this.scheduleItems[index])
      this.$set(this.scheduleItems, index, temp)
      
      // 同时交换对应的自定义返回码
      const tempCode = this.customTargetCodes[index + 1]
      this.$set(this.customTargetCodes, index + 1, this.customTargetCodes[index])
      this.$set(this.customTargetCodes, index, tempCode)
    },

    // 删除计划任务子项
    removeScheduleItem(index) {
      this.$confirm('确定要删除该产品吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.scheduleItems.splice(index, 1)
        this.$message.success('已删除产品')
      }).catch(() => {})
    },

    // 提交保存计划任务
    submitScheduleTasks() {
      // 校验数据
      for (let i = 0; i < this.scheduleItems.length; i++) {
        const item = this.scheduleItems[i]
        if (!item.product_name.trim()) {
          this.$message.warning(`产品 ${i + 1} 的产品名字不能为空`)
          return
        }
        // 获取实际的返回码（如果是自定义，取输入框的值）
        const actualCode = item.target_code === '__custom__' ? this.customTargetCodes[i] : item.target_code
        if (!actualCode || !actualCode.trim()) {
          this.$message.warning(`产品 ${i + 1} 的目标返回码不能为空`)
          return
        }
        if (!item.target_count || item.target_count < 1) {
          this.$message.warning(`产品 ${i + 1} 的目标数量必须大于0`)
          return
        }
      }

      this.scheduleSaving = true

      // 构造提交数据
      const submitData = {
        ison: this.scheduleEnabled,
        plans: this.scheduleItems.map((item, i) => {
          // 根据渠道模式构造 channels 数据
          let srcLimit = {}
          if (item.channelMode === 'all') {
            srcLimit['all'] = true
          } else {
            if(item.channels)
            {
              item.channels.map(ch => srcLimit[ch.name.trim()] = true)
            }
          }
          return {
            target: item.product_name.trim(),
            transformType: item.target_code === '__custom__' ? (this.customTargetCodes[i] || '').trim() : item.target_code.trim(),
            targetCount: Number(item.target_count),
            srcLimit
          }
        })
      }

      // 调用后端接口保存计划任务
      // TODO: 请根据实际后端接口调整请求参数
      const savedGroupName = this.scheduleGroupName
      SaveScheduleTasks(savedGroupName, {configs:JSON.stringify(submitData), version: this.scheduleVersion}).then(() => {
        this.$message.success('计划任务保存成功')
        this.scheduleDialogVisible = false
        // 保存成功后刷新主页面，更新计划任务状态
        this.getList()

        // 如果用户修改了计划任务（当未全部达成时），重置该组的弹出记录
        // 延迟获取最新状态检查，因为 getList 会异步执行
        if (submitData.ison && submitData.plans.length > 0) {
          // 检查是否有任何一个计划未达成（此时 count > 0 即为有任务）
          // 重置通知记录，允许下次全部达成时重新弹出
          resetNotification(savedGroupName)
        } else if (!submitData.ison) {
          // 如果关闭了总开关，也重置记录
          resetNotification(savedGroupName)
        }
      }).catch(error => {
        this.$message.error('保存计划任务失败:' + (error.message || error))
      }).finally(() => {
        this.scheduleSaving = false
      })
    },

    // 关闭计划任务对话框时的回调
    handleScheduleDialogClose() {
      this.scheduleGroupName = ''
      this.scheduleEnabled = false
      this.scheduleItems = []
    },

    // ==================== 计划任务状态详情方法 ====================

    // 点击"计划任务中"链接，显示计划任务状态
    handleShowPlanStatus(row) {
      this.planStatusGroupName = row.name
      this.planStatusDialogVisible = true
      this.planStatusList = []
      this.refreshPlanStatus()
    },

    // 刷新计划任务状态
    refreshPlanStatus() {
      this.planStatusLoading = true
      // 先获取计划任务配置，从中提取 targetCount（计划数量）
      const schedulePromise = GetScheduleTasks(this.planStatusGroupName).then(scheduleRes => {
        const planCountMap = {}
        try {
          const configs = scheduleRes.data.configs
          if (configs && configs !== '') {
            const data = JSON.parse(configs)
            const plans = data.plans || []
            plans.forEach(plan => {
              planCountMap[plan.target] = plan.targetCount || 0
            })
          }
        } catch (e) {
          console.log('解析计划任务配置失败:', e)
        }
        return planCountMap
      }).catch(() => {
        return {}
      })

      // 再获取计划任务执行状态详情
      const detailsPromise = GetGroupPlanDetails(this.planStatusGroupName).then(res => {
        return res.data || []
      }).catch(error => {
        this.$message.error('获取计划任务状态失败:' + (error.message || error))
        return []
      })

      // 合并两个接口的数据
      Promise.all([schedulePromise, detailsPromise]).then(([planCountMap, detailsList]) => {
        this.planStatusList = detailsList.map(item => ({
          target: item.target || '',
          transformType: item.transformType || '',
          // 计划数量优先从 GetScheduleTasks 的 targetCount 获取
          count: planCountMap[item.target] ||  0,
          currentCount: item.count || 0
        }))

        // 检查是否全部达成，弹出全局提示
        const groupName = this.planStatusGroupName
        if (groupName && isAllPlansCompleted(this.planStatusList)) {
          if (!hasNotifiedToday(groupName)) {
            setNotifiedToday(groupName)
            this.$alert(`${groupName}组计划任务已全部达成`, '计划任务完成', {
              confirmButtonText: '我知道了',
              type: 'success',
              center: true,
              dangerouslyUseHTMLString: false
            })
          }
        }
      }).finally(() => {
        this.planStatusLoading = false
      })
    },

    // 格式化目标返回码显示
    formatTransformType(type) {
      const map = {
        '1': '激活(1)',
        '2': '注册(2)',
        '3': '次留(3)',
        '5': '唤醒(5)',
        '8': '付费(8)'
      }
      return map[type] || type || '--'
    },

    // 获取当前数量样式类
    getCurrentCountClass(row) {
      if (!row.count || row.count <= 0) return ''
      const progress = (row.currentCount || 0) / row.count
      if (progress >= 1) return 'count-completed'
      if (progress >= 0.8) return 'count-warning'
      return ''
    },

    // 计算完成进度百分比
    getProgressPercentage(row) {
      if (!row.count || row.count <= 0) return 0
      const percentage = Math.min(100, Math.round(((row.currentCount || 0) / row.count) * 100))
      return percentage
    },

    // 获取进度条状态
    getProgressStatus(row) {
      if (!row.count || row.count <= 0) return ''
      const progress = (row.currentCount || 0) / row.count
      if (progress >= 1) return 'success'
      if (progress >= 0.8) return 'warning'
      return ''
    },

    // 关闭计划任务状态对话框时的回调
    handlePlanStatusDialogClose() {
      this.planStatusGroupName = ''
      this.planStatusList = []
    },
  }
}
</script>

<style scoped>

/* 新增描述列样式 */
.el-table .cell {
  white-space: pre-line;
  line-height: 1.5;
}

.dashboard {
  padding: 20px;
}
.toolbar {
  margin-bottom: 20px;
}
.el-input-group {
  width: 100%;
}

.kv-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.separator {
  margin: 0 10px;
  color: #909399;
}

.readonly-kv .kv-item {
  padding: 5px 0;
  border-bottom: 1px solid #ebeef5;
}

.kv-key {
  color: #409EFF;
  margin-right: 8px;
}

.kv-value {
  color: #67C23A;
}

.el-dialog__body {
  padding: 20px 30px;
}

.el-form-item {
  margin-bottom: 22px;
}

/* 添加按钮间距 */
.rule-config-cell {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.rule-tags-container {
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  min-height: 24px; /* 单行高度 */
  max-height: 72px; /* 3行高度 */
}

.rule-tag {
  display: inline-block;
  background: #f0f2f5;
  border-radius: 4px;
  padding: 2px 8px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  color: #606266;
  border: 1px solid #e4e7ed;
  white-space: nowrap;
}

.full-rule-content .rule-tag {
  margin-bottom: 4px;
}

.empty-rule {
  color: #909399;
  font-style: italic;
}

.view-rule-btn {
  flex-shrink: 0;
  align-self: center;
}

/* Tooltip样式优化 */
.el-tooltip__popper {
  max-width: 400px;
  max-height: 300px;
  overflow-y: auto;
  
}

/* ==================== 计划任务样式 ==================== */

.schedule-container {
  padding: 0 10px;
}

.schedule-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}

.schedule-switch-label {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}

.schedule-items-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.schedule-items-title {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}

.schedule-empty {
  padding: 30px 0;
}

.schedule-items-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.schedule-item-card {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fafafa;
  overflow: hidden;
}

.schedule-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  background: #f0f2f5;
  border-bottom: 1px solid #e4e7ed;
}

.schedule-item-index {
  font-size: 14px;
  font-weight: 500;
  color: #409EFF;
}

/* 计划任务卡片头部操作按钮组样式 */
.schedule-item-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.schedule-item-actions .el-button.is-circle {
  margin-left: 0;
  margin-right: 0;
}

.schedule-item-body {
  padding: 15px;
}

.schedule-item-body .el-form-item {
  margin-bottom: 15px;
}

.schedule-item-body .el-form-item:last-child {
  margin-bottom: 0;
}

/* 自定义返回码行样式 */
.custom-code-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

.custom-code-row .el-input {
  flex: 1;
}

/* 编辑模式切换栏样式 */
.schedule-edit-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  margin-bottom: 5px;
}

.schedule-edit-hint {
  font-size: 14px;
  color: #909399;
}

.schedule-edit-hint i {
  margin-right: 4px;
}

/* 渠道限制编辑器样式 */
.channel-limit-editor {
  width: 100%;
}

.channel-limit-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.channel-limit-row .el-input {
  flex: 1;
}

.channel-all-label {
  flex: 1;
  color: #67C23A;
  font-weight: 500;
  padding: 0 12px;
  line-height: 36px;
  background: #f0f9eb;
  border-radius: 4px;
  border: 1px solid #e1f3d8;
}

/* 默认产品单元格样式 */
.default-product-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 计划任务中链接样式 */
.schedule-active-link {
  color: #E6A23C !important;
  font-weight: 500;
  padding: 0 4px;
  border: 1px solid #E6A23C;
  border-radius: 4px;
  line-height: 20px;
  font-size: 12px;
  transition: all 0.2s;
}

.schedule-active-link:hover {
  background: #E6A23C;
  color: #fff !important;
}

/* 计划任务状态对话框样式 */
.plan-status-container {
  min-height: 200px;
}

.plan-status-container .el-table {
  font-size: 13px;
}

.count-completed {
  color: #67C23A;
  font-weight: 600;
}

.count-warning {
  color: #E6A23C;
  font-weight: 600;
}

</style>
